import { render } from "./VPatientDetails.vue?vue&type=template&id=8baa9430"
import script from "./VPatientDetails.vue?vue&type=script&lang=js"
export * from "./VPatientDetails.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/platform/components/offline-booking/VPatientDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8baa9430"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8baa9430', __exports__)) {
    api.reload('8baa9430', __exports__)
  }
  
  module.hot.accept("./VPatientDetails.vue?vue&type=template&id=8baa9430", () => {
    api.rerender('8baa9430', render)
  })

}


export default __exports__